// constants/short.js

export const SHORT_CONFIG = {
  PAGE_SIZE: 5,
  PRELOAD_RANGE: 1,
  CONTROLS_HIDE_DELAY: 3000,
  SCROLL_DEBOUNCE: 500,
  SCROLL_ANIMATION_DURATION: 800,
  INTERSECTION_THRESHOLDS: [0.5, 0.75, 1.0],
  DEFAULT_VOLUME: 0.5,
  MIN_VOLUME: 0,
  MAX_VOLUME: 1,
  VOLUME_STEP: 0.05
}

export const SHORT_KEYS = {
  ARROW_DOWN: "ArrowDown",
  ARROW_UP: "ArrowUp",
  SPACE: " "
}

export const VIDEO_ERRORS = {
  LOAD_ERROR: "Failed to load video",
  PLAY_ERROR: "Failed to play video",
  NETWORK_ERROR: "Network error"
}

export const SHORT_TYPES = {
  RANDOM: 0,
  RELATED: 8
}
